import 'css-chunksrc/client/scenes/milestone/styles.scss';export default {
  "milestone": "_milestone_hc7m9_1",
  "milestoneLoading": "_milestoneLoading_hc7m9_10",
  "loader": "_loader_hc7m9_16",
  "loaderMain": "_loaderMain_hc7m9_30",
  "main": "_main_hc7m9_37",
  "content": "_content_hc7m9_43",
  "secondaryCriteria": "_secondaryCriteria_hc7m9_49",
  "label": "_label_hc7m9_54",
  "row": "_row_hc7m9_60",
  "configurationIconBox": "_configurationIconBox_hc7m9_71",
  "configurationIcon": "_configurationIcon_hc7m9_71",
  "scrollWrapper": "_scrollWrapper_hc7m9_89",
  "timeline": "_timeline_hc7m9_98",
  "timestamp": "_timestamp_hc7m9_105",
  "comments": "_comments_hc7m9_113",
  "header": "_header_hc7m9_121",
  "contentHeader": "_contentHeader_hc7m9_134",
  "title": "_title_hc7m9_143",
  "rightContent": "_rightContent_hc7m9_151",
  "rightContentMultiProject": "_rightContentMultiProject_hc7m9_157",
  "contentProjectRedirection": "_contentProjectRedirection_hc7m9_161",
  "contentModal": "_contentModal_hc7m9_165",
  "constraints": "_constraints_hc7m9_170",
  "constraintsText": "_constraintsText_hc7m9_178",
  "attachments": "_attachments_hc7m9_184",
  "folderIcon": "_folderIcon_hc7m9_188",
  "icon": "_icon_hc7m9_192",
  "scenePlaceholder": "_scenePlaceholder_hc7m9_198"
};